import { gsap, ScrollTrigger } from "./globals.js";

document.addEventListener("DOMContentLoaded", () => {
    const allHeadings = document.querySelectorAll('.animate-heading');

    // Animate headings with .no-delay immediately
    allHeadings.forEach(heading => {
        if (heading.classList.contains('no-delay')) {
            const chars = heading.querySelectorAll(".char");

            gsap.fromTo(chars, {
                willChange: "opacity",
                opacity: 0,
            }, {
                opacity: 1,
                stagger: 0.75 / chars.length,
                duration: 1,
                ease: "power1.inOut",
                scrollTrigger: {
                    trigger: heading,
                    start: "top 80%",
                    once: true
                }
            });
        }
    });

    // Delay other headings until after layout has stabilized
    setTimeout(() => {
        allHeadings.forEach(heading => {
            if (!heading.classList.contains('no-delay')) {
                const chars = heading.querySelectorAll(".char");

                gsap.fromTo(chars, {
                    willChange: "opacity",
                    opacity: 0,
                }, {
                    opacity: 1,
                    stagger: 0.75 / chars.length,
                    duration: 1,
                    ease: "power1.inOut",
                    scrollTrigger: {
                        trigger: heading,
                        start: "top 80%",
                        once: true
                    }
                });
            }
        });

        ScrollTrigger.refresh();
    }, 500);
});
